import { Button } from '@eureca/ui';
import type { ErrorComponentProps } from '@tanstack/react-router';

function AlertCircleIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="8" x2="12" y2="12" />
      <line x1="12" y1="16" x2="12.01" y2="16" />
    </svg>
  );
}

export function ErrorFallback({ error, reset }: ErrorComponentProps) {
  const isDev = import.meta.env.DEV;

  return (
    <div className="flex min-h-dvh w-full items-center justify-center bg-background px-5">
      <div className="flex w-full max-w-md flex-col items-center gap-6 text-center">
        <div className="flex size-16 shrink-0 items-center justify-center rounded-full bg-destructive/10">
          <AlertCircleIcon className="size-6 text-destructive" />
        </div>

        <div className="flex flex-col gap-1.5">
          <h1 className="text-2xl font-semibold leading-none tracking-[-0.6px] text-foreground">
            Algo deu errado
          </h1>
          <p className="text-sm leading-5 text-accent-foreground">
            Não foi possível carregar esta página. Tente novamente ou volte para o início.
          </p>
        </div>

        {isDev && error instanceof Error && (
          <pre className="w-full overflow-x-auto rounded-lg border border-border bg-muted p-4 text-left text-xs text-muted-foreground">
            {error.message}
          </pre>
        )}

        <div className="flex w-full flex-col gap-3 sm:flex-row sm:justify-center">
          <Button type="button" size="lg" className="w-full sm:w-auto sm:px-8" onClick={reset}>
            Tentar novamente
          </Button>
          <Button
            type="button"
            variant="outline"
            size="lg"
            className="w-full sm:w-auto sm:px-8"
            onClick={() => {
              window.location.href = '/';
            }}
          >
            Voltar ao início
          </Button>
        </div>
      </div>
    </div>
  );
}
